module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_8017.9211ffa2.png";